import React from 'react';

import { TopImpactStoryBubble } from '../shared/components/TopImpactStoryBubble';

import { Footer } from './components/Footer';
import { useTopImpactStoriesMobile } from './hooks/useTopImpactStoriesMobile';

export const TopImpactStoriesMobile: React.FC = () => {
	const {
		data: { carouselStories, currentStoryIndex, containerRef, storyRefs },
		actions: { trackStoryClick, onStoryFocus, onScroll },
	} = useTopImpactStoriesMobile();

	return (
		<div className="relative z-10 lg:hidden">
			<div
				className="scroll-snap-x scroll-snap-mandatory mb-2 flex snap-x snap-mandatory gap-20 overflow-x-auto pb-2"
				data-testid="top-impact-stories-mobile-container"
				ref={containerRef}
				// eslint-disable-next-line react/forbid-dom-props
				style={{
					WebkitOverflowScrolling: 'touch',
					scrollbarWidth: 'none',
					msOverflowStyle: 'none',
				}}
				onScroll={onScroll}
			>
				<div aria-live="polite" className="sr-only" tabIndex={-1}>
					{carouselStories[currentStoryIndex].ariaLabel}
				</div>
				{carouselStories.map((story, index) => (
					<div key={`${story.key}-mobile`} ref={(el) => (storyRefs.current[index] = el)} className="snap-center py-8">
						<TopImpactStoryBubble
							story={story}
							isMobile
							isCenteredOnMobile={currentStoryIndex === index}
							onStoryFocus={() => onStoryFocus(index)}
							trackStoryClick={trackStoryClick}
						/>
					</div>
				))}
			</div>

			<Footer dataTestId={`${carouselStories[currentStoryIndex].dataTestIdBase}-summary`} />
		</div>
	);
};
